import * as angular from 'angular';
import 'angular-ui-router';
import shared from 'modules/shared';
import permissions from 'application/detail/permissions.json';
//Views
import FaqMenuView from './FaqMenuView.html';
import FaqContentView from './knowledgeBase/FaqContentView.html';
import FaqEditQuestionView from './editSet/FaqEditQuestionView.html';
import FaqUnknownQuestionsView from './unknownQuestions/FaqUnknownQuestionsView.html';
//Controllers
import { FaqController } from './knowledgeBase/FaqContentController';
import { FaqUnknownQuestionsController } from './unknownQuestions/FaqUnknownQuestionsController';
import { FaqEditQuestionController } from './editSet/FaqEditQuestionController';
//Services
import { FaqService } from './FaqService';
//
export default angular
    .module('templates.faq', ['ui.router', shared])
    .controller('FaqController', FaqController)
    .service('FaqService', FaqService)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('auth.application.detail.faq', {
            url: '/template/faq',
            redirectTo: 'auth.application.detail.faq.index',
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
            params: {
                area: 'basicConfigurations',
            },
            views: {
                'sidenav@auth.application.detail': {
                    template: FaqMenuView,
                },
            },
        })
            .state('auth.application.detail.faq.index', {
            url: '/',
            views: {
                'content@auth.application.detail': {
                    template: FaqContentView,
                    controller: FaqController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
        })
            .state('auth.application.detail.faq.unknownQuestions', {
            url: '/unknown-questions',
            views: {
                'content@auth.application.detail': {
                    template: FaqUnknownQuestionsView,
                    controller: FaqUnknownQuestionsController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
        })
            .state('auth.application.detail.faq.index.editFaqSet', {
            url: 'edit-set/:id',
            views: {
                'content@auth.application.detail': {
                    template: FaqEditQuestionView,
                    controller: FaqEditQuestionController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
        });
    }]).name;
